import React, { useState, Fragment } from 'react'
import _ from 'lodash';
import Select from 'react-select'
import selectStyles from '../styles/select'

type IOption = {
  label: string, 
  value: any
}
type FieldValues = {
  name: string, 
  error: any, 
  inputRef: any, 
  defaultValue: IOption,
  options: Array<IOption>,
  onFocus: Function,
  onChange: Function
};

const FieldSelect: React.FC<FieldValues> = ({ name, error, inputRef, defaultValue, options, onFocus, onChange }) => {
  const [fieldValue, setFieldValue] = useState(defaultValue);
  const handleChange = (o: any) => {
    setFieldValue(o);
    onChange(o);
  }

  return (
    <Fragment>
      <div className='i-form-group'>
        <Select className={`i-select ${fieldValue.value ? 'i-has-value' : ''}`} isSearchable={false}
          defaultValue={defaultValue}
          ref={inputRef}
          name={name}
          options={options} 
          styles={selectStyles} 
          onChange={handleChange}
          onFocus={() => onFocus()}
        />
        <label aria-hidden="true" className={`${fieldValue.value ? 'i-float' : ''}`}>{defaultValue.label}</label>
        {error ? <div className="i-form-group-text i-has-error">
          {error.message ? error.message : fieldValue.value ? `This is an incorrect format` : `This is required`}
        </div> : ''}
      </div>
    </Fragment>
  )
}

export default FieldSelect
